<template>
  <div class="ext">
    <div ref="chartDom" class="echarts-dom" :style="chartWrapStyle"></div>
  </div>
</template>
<script>
export default {
  props: {
    message: [Object, Array],
    /** 手机端紧凑布局：容器宽度 100%，避免固定 1400px 撑破弹窗 */
    compact: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      flow_list: null,
      time_periods: null,
      chartInstance: null
    }
  },
  computed: {
    chartWrapStyle () {
      if (this.compact) {
        return {
          width: '100%',
          height: '260px',
          minHeight: '220px',
          boxSizing: 'border-box'
        }
      }
      return { width: '1400px', height: '240px' }
    }
  },
  watch: {
    message (new1, new2) {
      console.log(new1.flow_list, '1', new2)
      this.flow_list = new1.flow_list
      this.time_periods = new1.time_periods
      this.drawLine()
    },
    compact () {
      this.$nextTick(() => this.drawLine())
    }
  },
  created () {
    console.log(this.message, '121')
  },
  mounted () {
    this.drawLine()
  },
  beforeDestroy () {
    if (this.chartInstance) {
      try {
        this.chartInstance.dispose()
      } catch (e) {}
      this.chartInstance = null
    }
  },

  methods: {
    drawLine () {
      console.log(this.flow_list, 'flow_list')
      const el = this.$refs.chartDom
      if (!el) return
      if (this.chartInstance) {
        try {
          this.chartInstance.dispose()
        } catch (e) {}
        this.chartInstance = null
      }
      this.chartInstance = this.$echarts.init(el)
      this.chartInstance.setOption({
        title: {
          subtext: '时段用水量'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            let time = params[0].name;
            let result = `<div style="font-weight: bold; margin-bottom: 5px;">${time}</div>`;
            params.forEach(param => {
              result += `
                <div style="display: flex; align-items: center; margin: 2px 0;">
                  <span style="display: inline-block; width: 10px; height: 10px; 
                               background-color: ${param.color}; border-radius: 50%; margin-right: 5px;"></span>
                  <span>${param.seriesName}: ${param.value} m³</span>
                </div>
              `;
            });
            return result;
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // prettier-ignore
          data: this.time_periods
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          }
        },
        series: [
          {
            name: '用水量',
            type: 'line',
            smooth: true,
            // prettier-ignore
            data: this.flow_list
          }
        ]
      })
      this.$nextTick(() => {
        if (this.chartInstance) {
          this.chartInstance.resize()
        }
      })
    }
  }
}
</script>
<style scoped>
.ext {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.echarts-dom {
  max-width: 100%;
}
</style>
